<template>
        <div class="card bg-light shadow-lg p-3 mb-5">
            <div class="card-body">
                <!-- Header / Toolbar -->
                <div class="d-flex justify-content-between align-items-start flex-wrap mb-3">
                    <div>
                        <h5 class="card-title fw-bolder mb-1" style="color:#061704">Group Messaging</h5>
                        <p class="text-muted small mb-0">Send SMS to farmer groups</p>
                    </div>
                    <div class="d-flex gap-2 align-items-center mt-2 mt-md-0 flex-wrap">
                        <Transition>
                            <p style="font-size:11px" v-if="resMsg" class="text-warning text-capitalize d-inline fw-bold px-3 mb-0">{{resMsg}}</p>
                        </Transition>

                        <div class="card border-0 mt-0 d-inline" v-if="showupdate">
                            <div class="card-body p-0 text-start row gx-2">
                                <div class="col-auto">
                                    <label for="updateLabel" class="form-label" style="font-size:12px !important">Label</label>
                                    <input type="text" class="form-control form-control-sm mb-0" required v-model="extGroup.label" id="updateLabel" placeholder="eg.Livestock Farmers">
                                </div>
                                <div class="col-auto">
                                    <label for="updateDescription" class="form-label" style="font-size:12px !important">Description</label>
                                    <input type="text" class="form-control form-control-sm mb-0" id="updateDescription" required v-model="extGroup.description" placeholder="lorem ipsum init">
                                </div>
                                <div class="col-auto">
                                    <button type="submit" class="btn btn-sm rounded-pill text-light d-inline mt-3" style="font-size:12px !important; background-image: linear-gradient(198deg, #000000, #1f6c15) !important;" @click="updateGroup()">Update</button>
                                </div>
                            </div>
                        </div>

                        <div class="dropdown d-inline" v-if="currentStep === 1">
                            <a href="#" class="dropdown-toggle text-light fw-bold text-decoration-none btn btn-sm btn-secondary rounded-pill"  data-bs-toggle="dropdown" aria-expanded="false">+<i class="bi bi-people"></i></a>
                            <div class="dropdown-menu px-3" style="width:2.8in" aria-labelledby="dropdownMenuButton1">
                                <div class="mb-2">
                                    <label for="createLabel" class="form-label" style="font-size:13px !important">Label</label>
                                    <input type="text" class="form-control form-control-sm" required v-model="extGroup.label" id="createLabel" placeholder="eg.Livestock Farmers">
                                </div>
                                <div class="mb-2">
                                    <label for="createDescription" class="form-label" style="font-size:13px !important">Description</label>
                                    <input type="text" class="form-control form-control-sm" id="createDescription" required v-model="extGroup.description" placeholder="lorem ipsum init">
                                </div>
                                <button type="submit" class="btn btn-sm float-end rounded-pill text-light" style="font-size:13px !important; background-image: linear-gradient(198deg, #000000, #1f6c15) !important;" @click="createGroup()">Create group</button>
                            </div>
                        </div>
                        <i class="btn bi bi-trash3 rounded-pill" :class="delete_display" @click="deletedata" style="color:#fa0101; " v-if="currentStep === 1"></i>
                        <button type="button" style="background-color:#061704"  class="btn rounded-pill px-3 text-light shadow-md btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" v-if="currentStep === 1">+ contact</button>
                        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <Addcontent  @modalSubmit="reloadList()"  :updatedata="updateValues"/>
                        </div>
                    </div>
                </div>

                <!-- Stepper -->
                <div class="stepper-wrapper mb-4">
                    <div class="stepper-item" :class="{'active': currentStep === 1, 'completed': currentStep > 1}" @click="currentStep > 1 ? goToStep(1) : null">
                        <div class="step-counter">1</div>
                        <div class="step-name">Groups</div>
                    </div>
                    <div class="stepper-connector" :class="{'completed': currentStep >= 2}"></div>
                    <div class="stepper-item" :class="{'active': currentStep === 2, 'completed': currentStep > 2, 'disabled': currentStep < 2}" @click="currentStep > 2 ? goToStep(2) : null">
                        <div class="step-counter">2</div>
                        <div class="step-name">Farmers</div>
                    </div>
                    <div class="stepper-connector" :class="{'completed': currentStep >= 3}"></div>
                    <div class="stepper-item" :class="{'active': currentStep === 3, 'completed': currentStep > 3, 'disabled': currentStep < 3}" @click="currentStep > 3 ? goToStep(3) : null">
                        <div class="step-counter">3</div>
                        <div class="step-name">Messaging</div>
                    </div>
                    <div class="stepper-connector" :class="{'completed': currentStep >= 4}"></div>
                    <div class="stepper-item" :class="{'active': currentStep === 4, 'completed': currentStep > 4, 'disabled': currentStep < 4}" @click="currentStep > 4 ? goToStep(4) : null">
                        <div class="step-counter">4</div>
                        <div class="step-name">Attachments</div>
                    </div>
                    <div class="stepper-connector" :class="{'completed': currentStep >= 5}"></div>
                    <div class="stepper-item" :class="{'active': currentStep === 5, 'disabled': currentStep < 5}">
                        <div class="step-counter">5</div>
                        <div class="step-name">Review</div>
                    </div>
                </div>

                <!-- Step Title -->
                <div class="mb-4">
                    <h5 class="fw-bold mb-1">{{ stepTitle }}</h5>
                    <p class="text-muted small">{{ stepSubtitle }}</p>
                </div>

                <!-- Step 1: Groups -->
                <div v-if="currentStep === 1">
                    <p v-if="extgroups.length == 0" class="text-center text-muted mt-4 mb-0 small"><i class="bi bi-people fs-4 d-block"></i>No groups yet. Create one to get started.</p>
                    <div class="row g-3">
                        <div class="col-12 col-md-6 col-lg-4" v-for="(group, i) in extgroups" :key="i">
                            <div class="card group-card h-100 shadow-sm" :class="{'border-success': selectedGroup && selectedGroup.id === group.id}">
                                <div class="card-body d-flex flex-column">
                                    <div class="d-flex justify-content-between align-items-start">
                                        <h6 class="card-title text-truncate mb-1" style="font-size:14px">{{ group.label }}</h6>
                                        <div class="dropdown">
                                            <button class="btn btn-link btn-sm p-0 text-muted" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i class="bi bi-three-dots-vertical"></i></button>
                                            <ul class="dropdown-menu dropdown-menu-end">
                                                <li><a class="dropdown-item small" href="#" @click="groupid = group.id; showupdate = true; extGroup.label = group.label; extGroup.description = group.description"><i class="bi bi-pencil me-1"></i> Edit</a></li>
                                                <li><a class="dropdown-item small text-danger" href="#" @click="deleteGroup(group.id)"><i class="bi bi-trash me-1"></i> Delete</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <p class="text-muted small mb-3 flex-grow-1" style="font-size:12px">{{ group.description || 'No description' }}</p>
                                    <button class="btn btn-sm w-100 rounded-pill text-light" style="background-color:#1f6c15" @click="selectGroup(group)">Select Group</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Step 2: Farmers -->
                <div v-if="currentStep === 2">
                    <div class="card shadow-sm">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h6 class="mb-0" style="font-size:14px">Farmers in <span class="fw-bold">{{ selectedGroup ? selectedGroup.label : '' }}</span></h6>
                                <span class="badge bg-secondary rounded-pill" style="font-size:11px">{{ extensions.length }} farmer{{ extensions.length !== 1 ? 's' : '' }}</span>
                            </div>
                            <div style="max-height: 4in; overflow-y: auto;">
                                <p v-if="extensions.length == 0" class="text-center text-muted mt-4 small"><i class="bi bi-person fs-4 d-block"></i>No farmers in this group yet.</p>
                                <div class="alert rounded-pill text-start shadow-sm  position-relative" v-for="(extension ,i) in extensions" :key="i" style="background-color: rgb(170 255 159)" role="alert">
                                    <strong style="font-size:13px" class="text-capitalize">{{extension.extension.name}} </strong> 
                                    <small  style="font-size:10px" >
                                        <span class="mx-3" v-if="extension.extension.isPhoneVisible">{{ extension.extension.phone }}</span>
                                        <span class="mx-3" v-else>{{ maskPhone(extension.extension.phone) }}</span>
                                        <i @click="toggleVisibility(i)" class="px-3" style="font-size:13px" :class="extension.isPhoneVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                                    </small>
                                    <button type="button" class="btn-close btn-close-sm position-absolute top-0 end-0 me-2 mt-2"  data-bs-dismiss="alert" aria-label="Close" @click="deleteGrouplink(extension.id, extension.extension.phone), groupid=extension.extGroupId"></button>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between mt-3">
                                <button class="btn btn-outline-secondary btn-sm rounded-pill" @click="goToStep(1)"><i class="bi bi-arrow-left me-1"></i> Back</button>
                                <button class="btn btn-success btn-sm rounded-pill" @click="goToStep(3)" :disabled="extensions.length === 0">Next: Messaging <i class="bi bi-arrow-right ms-1"></i></button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Step 3: Messaging -->
                <div v-if="currentStep === 3">
                    <div class="card shadow-lg messaging-card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <h5 class="card-title text-start fs-6 text-muted mb-0">Compose Message</h5>
                                <span class="badge bg-secondary rounded-pill" style="font-size:11px" v-if="phoneNo.length > 0">{{phoneNo.length}} recipient{{phoneNo.length > 1 ? 's' : ''}}</span>
                            </div>
                            <div class="message-composer">
                                <textarea class="form-control form-control-sm message-textarea" placeholder="Type your SMS message..." aria-label="Message text" v-model="smsMsg"></textarea>
                            </div>
                            <div class="d-flex justify-content-between mt-3">
                                <button class="btn btn-outline-secondary btn-sm rounded-pill" @click="goToStep(2)"><i class="bi bi-arrow-left me-1"></i> Back</button>
                                <button class="btn btn-success btn-sm rounded-pill" @click="goToStep(4)">Next: Attachments <i class="bi bi-arrow-right ms-1"></i></button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Step 4: Attachments -->
                <div v-if="currentStep === 4">
                    <div class="card shadow-lg">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h5 class="card-title text-start fs-6 text-muted mb-0">Attachments</h5>
                                <span class="badge bg-secondary rounded-pill" style="font-size:11px" v-if="phoneNo.length > 0">{{phoneNo.length}} recipient{{phoneNo.length > 1 ? 's' : ''}}</span>
                            </div>

                            <div class="d-flex gap-2 mb-3">
                                <button type="button" class="btn btn-sm rounded-pill flex-grow-1" :class="attachTab === 'links' ? 'btn-success' : 'btn-outline-secondary'" @click="attachTab = 'links'">
                                    <i class="bi bi-link-45deg me-1"></i> Links
                                </button>
                                <button type="button" class="btn btn-sm rounded-pill flex-grow-1" :class="attachTab === 'advisories' ? 'btn-success' : 'btn-outline-secondary'" @click="attachTab = 'advisories'">
                                    <i class="bi bi-journal-text me-1"></i> Advisories
                                </button>
                                <button type="button" class="btn btn-sm rounded-pill flex-grow-1" :class="attachTab === 'voice' ? 'btn-success' : 'btn-outline-secondary'" @click="attachTab = 'voice'">
                                    <i class="bi bi-mic-fill me-1"></i> Voice
                                </button>
                            </div>

                            <!-- Links tab -->
                            <div v-if="attachTab === 'links'" class="list-group" style="font-size:13px; max-height: 280px; overflow: auto;">
                                <div class="fw-bold text-muted d-flex align-items-center px-2 py-1 small">
                                    <i class="bi bi-broadcast-pin me-1"></i> <span class="fw-bolder">Your Podcasts</span>
                                </div>
                                <a href="#" v-for="(podcast, i) in podcasts" :key="'your-'+i" class="list-group-item text-start list-group-item-action border-0 py-1 ps-4 capitalize rounded-2 text-truncate" @click="links.push({link:podcast.webViewLink, name:podcast.name})">
                                    {{ podcast.name }}
                                </a>

                                <hr class="my-1">

                                <div class="fw-bold text-muted d-flex align-items-center px-2 py-1 small">
                                    <i class="bi bi-bookmark-star-fill me-1 text-success"></i> <span class="fw-bolder">Favourites</span>
                                </div>
                                <a href="#" v-for="(podcast, i) in publicPodcasts" :key="'public-'+i" class="list-group-item list-group-item-action py-1 ps-4 border-0 rounded-2 text-truncate" @click="links.push({link:podcast.webViewLink, name:podcast.name})">
                                    {{ podcast.name }}
                                </a>
                            </div>

                            <!-- Advisories tab -->
                            <div v-if="attachTab === 'advisories'" style="font-size:13px; max-height: 400px; overflow: auto;">
                                <div class="mb-2">
                                    <label class="form-label small text-muted mb-1">Crop</label>
                                    <select class="form-select form-select-sm rounded-2" v-model="selectedCrop" @change="onCropSelected()">
                                        <option value="" disabled selected>Choose a crop</option>
                                        <option v-for="crop in crops" :key="crop.crop_id" :value="crop.crop_id">{{ crop.crop }}</option>
                                    </select>
                                </div>
                                <div class="mb-2" v-if="cropActivities.length > 0">
                                    <label class="form-label small text-muted mb-1">Activity</label>
                                    <select class="form-select form-select-sm rounded-2" v-model="selectedActivity" @change="onActivitySelected()">
                                        <option value="" disabled selected>Choose an activity</option>
                                        <option v-for="activity in cropActivities" :key="activity.act_id" :value="activity.act_id">{{ activity.activity }}</option>
                                    </select>
                                </div>
                                <div v-if="activityDetails" class="border rounded-2 text-start p-2 bg-light">
                                    <div class="form-check mb-2">
                                        <input class="form-check-input" type="checkbox" id="activityDesc" v-model="pendingAdvisory.includeDescription">
                                        <label class="form-check-label small" for="activityDesc">
                                            <strong>Activity description</strong><br>
                                            <span class="text-muted text-start">{{ (activityDetails.content_short || activityDetails.content_long || activityDetails.activity).slice(0, 80) }}{{ ((activityDetails.content_short || activityDetails.content_long || activityDetails.activity).length > 80) ? '...' : '' }}</span>
                                        </label>
                                    </div>
                                    <div v-if="activityDetails.risks && activityDetails.risks.length > 0">
                                        <div class="fw-bold text-muted small mb-1">Risk advisories</div>
                                        <div class="form-check mb-1" v-for="risk in activityDetails.risks" :key="risk.risk_id">
                                            <div class="small fw-semibold ms-1">{{ risk.risk }}</div>
                                            <div class="form-check ms-3" v-for="adv in (risk.advisories || [])" :key="adv.adv_id">
                                                <input class="form-check-input" type="checkbox" :id="'adv-'+adv.adv_id" :value="adv.adv_id" :checked="pendingAdvisory.selectedAdvisories.includes(adv.adv_id)" @change="toggleAdvisory(adv.adv_id)">
                                                <label class="form-check-label small text-start  text-muted" :for="'adv-'+adv.adv_id">{{ adv.advisory.slice(0, 80) }}{{ adv.advisory.length > 80 ? '...' : '' }}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-end mt-2">
                                        <button type="button" class="btn btn-sm btn-success rounded-pill" @click="attachAdvisoryTexts()" :disabled="advisoryPreview.length === 0">
                                            <i class="bi bi-plus-circle me-1"></i> Attach {{ advisoryPreview.length }} item{{ advisoryPreview.length > 1 ? 's' : '' }}
                                        </button>
                                    </div>
                                </div>
                                <div v-else-if="selectedCrop && !selectedActivity" class="text-muted small text-center py-3">Select an activity to view its advisories.</div>
                                <div v-else-if="!selectedCrop" class="text-muted small text-center py-3">Select a crop to begin.</div>
                            </div>

                            <!-- Voice tab -->
                            <div v-if="attachTab === 'voice'" style="font-size:13px; max-height: 400px; overflow: auto;">
                                <div class="mb-2">
                                    <label class="form-label small text-muted mb-1">Crop</label>
                                    <select class="form-select form-select-sm rounded-2" v-model="selectedCrop" @change="onCropSelected()">
                                        <option value="" disabled selected>Choose a crop</option>
                                        <option v-for="crop in crops" :key="crop.crop_id" :value="crop.crop_id">{{ crop.crop }}</option>
                                    </select>
                                </div>
                                <div class="mb-2" v-if="cropActivities.length > 0">
                                    <label class="form-label small text-muted mb-1">Activity</label>
                                    <select class="form-select form-select-sm rounded-2" v-model="selectedActivity" @change="onActivitySelected()">
                                        <option value="" disabled selected>Choose an activity</option>
                                        <option v-for="activity in cropActivities" :key="activity.act_id" :value="activity.act_id">{{ activity.activity }}</option>
                                    </select>
                                </div>
                                <div v-if="activityDetails" class="border rounded-2 text-start p-2 bg-light">
                                    <div v-if="activityAudio.length > 0" class="mb-2">
                                        <div class="fw-bold text-muted small mb-1"><i class="bi bi-mic-fill me-1"></i>Activity audio</div>
                                        <div class="form-check mb-1" v-for="(audioItem, idx) in activityAudio" :key="audioItem.id">
                                            <input class="form-check-input" type="radio" :id="'audio-'+audioItem.id" name="activityAudio" :value="audioItem" v-model="selectedAudio">
                                            <label class="form-check-label small" :for="'audio-'+audioItem.id">
                                                {{ audioItem.audio?.gName || 'Audio ' + (idx + 1) }}
                                                <span class="text-muted text-start" v-if="audioItem.language?.language">({{ audioItem.language.language }})</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div v-else class="text-muted small text-center py-3">No audio files for this activity.</div>
                                </div>
                                <div v-else-if="selectedCrop && !selectedActivity" class="text-muted small text-center py-3">Select an activity to view its audio.</div>
                                <div v-else-if="!selectedCrop" class="text-muted small text-center py-3">Select a crop to begin.</div>
                            </div>

                            <div class="d-flex flex-wrap gap-1 mt-3" v-if="hasAttachments || selectedAudio">
                                <span class="badge rounded-pill attachment-chip link-chip" v-for="(link, i) in links" :key="'link-'+i">
                                    <i class="bi bi-link-45deg me-1"></i> {{ link.name }}
                                    <i class="bi bi-x-circle ms-1 remove-chip" @click="removeLink(i)"></i>
                                </span>
                                <span class="badge rounded-pill attachment-chip advisory-chip" v-for="(item, i) in advisoryTexts" :key="'advtxt-'+i">
                                    <i class="bi bi-journal-text me-1"></i> {{ item.name }}
                                    <i class="bi bi-x-circle ms-1 remove-chip" @click="removeAdvisoryText(i)"></i>
                                </span>
                                <span class="badge rounded-pill attachment-chip voice-chip" v-if="selectedAudio">
                                    <i class="bi bi-mic-fill me-1"></i> {{ selectedAudio.audio?.gName || 'Voice audio' }}
                                    <i class="bi bi-x-circle ms-1 remove-chip" @click="selectedAudio = null"></i>
                                </span>
                                <button type="button" class="btn btn-link btn-sm text-danger p-0 ms-1" style="font-size:11px" @click="clearAllAttachments(); selectedAudio = null" title="Clear all attachments">Clear all</button>
                            </div>

                            <div class="d-flex justify-content-between mt-3">
                                <button class="btn btn-outline-secondary btn-sm rounded-pill" @click="goToStep(3)"><i class="bi bi-arrow-left me-1"></i> Back</button>
                                <button class="btn btn-success btn-sm rounded-pill" @click="goToStep(5)">Next: Review <i class="bi bi-arrow-right ms-1"></i></button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Step 5: Review -->
                <div v-if="currentStep === 5">
                    <div class="card shadow-lg">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h5 class="card-title text-start fs-6 text-muted mb-0">Review & Send</h5>
                                <span class="badge bg-secondary rounded-pill" style="font-size:11px">{{phoneNo.length}} recipient{{phoneNo.length > 1 ? 's' : ''}}</span>
                            </div>

                            <div class="mb-3">
                                <div class="small fw-bold text-muted">Group</div>
                                <div class="small">{{ selectedGroup?.label || 'No group selected' }}</div>
                            </div>

                            <div class="mb-3">
                                <div class="small fw-bold text-muted">Message preview</div>
                                <pre class="bg-light p-2 rounded-2 small mb-0" style="white-space: pre-wrap; max-height: 3in; overflow: auto;">{{ composedMessage || 'No message content' }}</pre>
                            </div>

                            <div class="mb-3">
                                <div class="small fw-bold text-muted">Attachments</div>
                                <div class="d-flex flex-wrap gap-1 mt-1">
                                    <span class="badge rounded-pill attachment-chip link-chip" v-for="(link, i) in links" :key="'link-'+i">
                                        <i class="bi bi-link-45deg me-1"></i> {{ link.name }}
                                    </span>
                                    <span class="badge rounded-pill attachment-chip advisory-chip" v-for="(item, i) in advisoryTexts" :key="'advtxt-'+i">
                                        <i class="bi bi-journal-text me-1"></i> {{ item.name }}
                                    </span>
                                    <span class="badge rounded-pill attachment-chip voice-chip" v-if="selectedAudio">
                                        <i class="bi bi-mic-fill me-1"></i> {{ selectedAudio.audio?.gName || 'Voice audio' }}
                                    </span>
                                    <span v-if="!hasAttachments && !selectedAudio" class="text-muted small">None</span>
                                </div>
                            </div>

                            <div class="d-flex justify-content-between mt-3">
                                <button class="btn btn-outline-secondary btn-sm rounded-pill" @click="goToStep(4)"><i class="bi bi-arrow-left me-1"></i> Back</button>
                                <div class="d-flex gap-2">
                                    <button @click="sendSms()" type="button" class="btn text-light btn-sm rounded-pill send-btn" :disabled="!canSend || isLoading" :style="!canSend ? 'background-color:#6c757d;' : 'background-color:#1f6c15;'">
                                        <span v-if="isLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                        <span v-if="!isLoading"><i class="bi bi-send-fill me-1"></i></span>
                                        Send SMS
                                    </button>
                                    <button @click="sendVoiceCall()" type="button" class="btn btn-primary btn-sm rounded-pill" :disabled="isVoiceLoading" title="Send selected activity audio as a voice call">
                                        <span v-if="isVoiceLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                        <span v-if="!isVoiceLoading"><i class="bi bi-telephone-outbound me-1"></i></span>
                                        Voice Call
                                    </button>
                                </div>
                            </div>

                            <div v-if="smsRes" class="alert alert-success alert-sm mt-2 py-1 px-2 text-center small mb-0" role="alert">
                                {{ smsRes }}
                            </div>
                            <div v-if="voiceRes" class="alert alert-info alert-sm mt-2 py-1 px-2 text-center small mb-0" role="alert">
                                {{ voiceRes }}
                            </div>
                            <div v-if="phoneNo.length === 0" class="alert alert-warning alert-sm mt-2 py-1 px-2 text-center small mb-0" role="alert">
                                <i class="bi bi-info-circle me-1"></i> Select a group to see recipients
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

    <script>
    import axios from 'axios'    
        import Addcontent from './contactmodal.vue'


    export default {
        components: { 
            Addcontent
        },
        data() {
            return {
                isLoading: false,
                isMfs:false,
                refCount: 0,
                links:[],
                advisoryTexts:[],
                podcasts:[],
                publicPodcasts:[],
                smsRes:'',
                smsMsg:'',
                phoneNo:[],
                groupid:null,
                showupdate:false,
                searchText:'',
                extgroups:[],
                extensions:[],
                searchRes:[],
                updateValues:null,
                checkeddata : [],
                allSelected: false,
                resMsg:'',
                extGroup:{
                    label:'',
                    description:''
                },
                // stepper state
                currentStep: 1,
                selectedGroup: null,
                // crop advisory attachment picker
                crops:[],
                selectedCrop:null,
                cropActivities:[],
                selectedActivity:null,
                activityDetails:null,
                activityAudio:[],
                selectedAudio:null,
                voiceRes:'',
                isVoiceLoading:false,
                attachTab:'links',
                pendingAdvisory:{
                    includeDescription:false,
                    selectedAdvisories:[]
                }

            }
        },
        beforeMount(){
           this.getallgroups();
           this.getPodcasts();
           this.getCrops();
            //   this.getPublicPodcasts();
           this.getMfsMsg();
        },
        computed:{
            delete_display(){
                if(this.checkeddata.length == 0){
                    return 'd-none'
                }
            },
            selectAll: {
                get: function () {
                    return this.contacts ? this.checkeddata.length == this.contacts.length : false;
                },
                set: function (value) {
                    var checkeddata = [];
                    if (value) {
                        this.contacts.forEach(function (data) {
                            checkeddata.push(data.id);
                        });
                    }
                    this.checkeddata = checkeddata;
                }
            },
            hasAttachments(){
                return this.links.length > 0 || this.advisoryTexts.length > 0;
            },
            canSend(){
                return (this.smsMsg.trim().length > 0 || this.hasAttachments) && this.phoneNo.length > 0;
            },
            advisoryPreview(){
                const parts = [];
                if(this.pendingAdvisory.includeDescription && this.activityDetails){
                    const txt = this.activityDetails.content_short || this.activityDetails.content_long || this.activityDetails.activity;
                    parts.push({ type:'activity', name: 'Activity: ' + this.activityDetails.activity, text: txt });
                }
                if(this.activityDetails && this.activityDetails.risks){
                    this.activityDetails.risks.forEach(risk => {
                        (risk.advisories || []).forEach(adv => {
                            if(this.pendingAdvisory.selectedAdvisories.includes(adv.adv_id)){
                                parts.push({ type:'advisory', name: 'Risk: ' + (risk.risk || 'Advisory'), text: adv.advisory });
                            }
                        });
                    });
                }
                return parts;
            },
            stepTitle(){
                return ['Choose a Group', 'Review Farmers', 'Compose Message', 'Add Attachments', 'Review & Send'][this.currentStep - 1]
            },
            stepSubtitle(){
                return [
                    'Select the group you want to message',
                    'Confirm the farmers who will receive the message',
                    'Write your SMS message',
                    'Attach links, advisories, or select a voice recording',
                    'Preview everything before sending'
                ][this.currentStep - 1]
            },
            canSendVoice(){
                return this.selectedAudio && this.phoneNo.length > 0 && !this.isVoiceLoading;
            },
            composedMessage(){
                let linkarr = []
                this.links.forEach(link => { linkarr.push(link.link) })
                let links2send = linkarr.join('\n -------------------- \n')

                let advisoryParts = []
                this.advisoryTexts.forEach(item => { advisoryParts.push(`${item.name}\n${item.text}`) })
                let advisory2send = advisoryParts.join('\n\n--------------------\n\n')

                let parts = []
                if(this.smsMsg.trim().length > 0) parts.push(this.smsMsg.trim())
                if(links2send.trim().length > 0) parts.push(links2send)
                if(advisory2send.trim().length > 0) parts.push(advisory2send)
                return parts.join('\n\n--------------------\n\n')
            }
        },
        methods: {
            // groups*************************************************************************
            getallgroups(){
                 var token = this.getCookie('token')

                axios.get('https://aghub.miphost.com/api/broadcast/group/show', 
                    { headers:{'Authorization': `Bearer ${token}`}})
                .then(response =>  {
                    console.log(response.data)
                    this.extgroups = response.data
                }).catch(error => {
                    console.log(error);
                })
            },
            createGroup(){
                var token = this.getCookie('token')
                axios.post('https://aghub.miphost.com/api/broadcast/group', this.extGroup,
                    {headers:{'Authorization': `Bearer ${token}`, 'Content-Type':'application/json'}}
                ).then(response =>{
                    this.resMsg = response.data.label + ' has been created'
                    this.extGroup.label=''
                    this.extGroup.description=''
                    setTimeout(() => {
                            this.resMsg=''
                    }, 2000);

                }).catch(error =>{
                    console.log(error)
                    this.resMsg = error.response.data
                    setTimeout(() => {
                        this.resMsg=''
                    }, 2000);
                })
            },
             updateGroup(){
                 var token = this.getCookie('token')
                axios.post('https://aghub.miphost.com/api/broadcast/group/update/'+ this.groupid, 
                    this.extGroup,
                    {headers:{'Authorization': `Bearer ${token}`}})
                .then(response =>  {
                     this.resMsg = response.data
                    setTimeout(() => {
                            this.extGroup.label=''
                            this.extGroup.description=''
                            this.resMsg=''
                            this.showupdate = !this.showupdate
                            this.getallgroups()
                    }, 2000);

                }).catch(error => {
                    console.log(error);
                })
            },
            deleteGroup(groupid){
                var token = this.getCookie('token')
                axios.get('https://aghub.miphost.com/api/broadcast/group/delete/'+ groupid, 
                    { headers:{'Authorization': `Bearer ${token}`}})
                .then(response =>  {
                    console.log(response)
                    this.getallgroups()
                }).catch(error => {
                    console.log(error);
                })
            },
            selectGroup(group){
                this.selectedGroup = group
                this.getallExt(group.id)
                this.currentStep = 2
            },
            goToStep(step){
                if(step === 1){
                    this.selectedGroup = null
                    this.extensions = []
                    this.phoneNo = []
                }
                this.currentStep = step
            },

            //group links************************************************************************ 
            getallExt(groupid){
                var token = this.getCookie('token')
                axios.get('https://aghub.miphost.com/api/broadcast/grouplink/show/'+ groupid, 
                    { headers:{'Authorization': `Bearer ${token}`}})
                .then(response =>  {
                    var filtered = response.data.filter((i)=>{
                       return i.extension != null
                    })  

                    this.extensions = filtered.map(contact => ({
                        ...contact,
                        extension: {
                            ...contact.extension, 
                            isPhoneVisible: false
                        }
                    }));
                    
                    this.phoneNo = []
                    this.extensions.forEach(contact => {
                        this.phoneNo.push(contact.extension.phone)
                    });
                }).catch(error => {
                    console.log(error);
                })
            },
            deleteGrouplink(extId, phoneNo){
                var token = this.getCookie('token')
                axios.get('https://aghub.miphost.com/api/broadcast/grouplink/delete/'+ extId, 
                    { headers:{'Authorization': `Bearer ${token}`}})
                .then(response =>  {
                    const index = this.phoneNo.indexOf(phoneNo);
                    if (index > -1) { // only splice array when item is found
                        this.phoneNo.splice(index, 1); // 2nd parameter means remove one item only
                    }
                }).catch(error => {
                    console.log(error);
                })
            },
            setLoading(isLoading) {
            if (isLoading) {
                this.refCount++;
                this.isLoading = true;
            } else if (this.refCount > 0) {
                    this.refCount--;
                    this.isLoading = (this.refCount > 0);
                    setInterval(() => {      
                    }, 2000);
                }
            },
            getMfsMsg(){
               var msg = null
               msg = this.getCookie('msg')
                if(msg && msg.length > 0 && msg != null && msg != 'null'){
                    this.smsMsg = msg
                    this.isMfs = true
                }
            },
            sendSms(){
                axios.interceptors.request.use((config) => {
                    this.setLoading(true);
                    return config;
                    }, (error) => {
                    this.setLoading(false);
                    return Promise.reject(error);
                });

                axios.interceptors.response.use((response) => {
                    this.setLoading(false);
                    return response;
                    }, (error) => {
                    this.setLoading(false);
                    return Promise.reject(error);
                });



                var token = this.getCookie('token')
                let linkarr = []
                this.links.forEach(link => {
                    linkarr.push(link.link)
                });
                let links2send = linkarr.join('\n -------------------- \n')

                let advisoryParts = []
                this.advisoryTexts.forEach(item => {
                    advisoryParts.push(`${item.name}\n${item.text}`)
                })
                let advisory2send = advisoryParts.join('\n\n--------------------\n\n')

                let parts = []
                if(this.smsMsg.trim().length > 0) parts.push(this.smsMsg.trim())
                if(links2send.trim().length > 0) parts.push(links2send)
                if(advisory2send.trim().length > 0) parts.push(advisory2send)
                let message = parts.join('\n\n--------------------\n\n')

                if(!message.trim()){
                    this.smsRes = 'Please enter a message or attach a link/advisory'
                    setTimeout(() => { this.smsRes = '' }, 2000)
                    return
                }

                axios.post('https://api.mnotify.com/api/sms/quick?key=58EXw7cogcPXEYo1CZTmebRc5', 
                    {
                        'recipient': this.phoneNo,
                        'sender': this.isMfs ? 'SI-MFS':'AGHUB',
                        'message': message   
                    },
                    {headers:
                        {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json' 
                        }
                    })
                .then(response =>  {
                    if(response.data.code == 2000){
                        this.smsRes = response.data.message
                        this.smsMsg=''
                        linkarr = []
                	    this.links = []
                        this.advisoryTexts = []
                        setTimeout(() => {
                                this.smsRes=''
                        }, 2000);
                    } 
                }).catch(error => {
                    console.log(error);
                })
                // axios.post('https://aghub.miphost.com/api/broadcast/contact/notify', 
                //     {
                //         recipients:this.phoneNo,
                //         msg:this.smsMsg
                //     },
                //     { headers:{'Authorization': `Bearer ${token}`}})
                // .then(response =>  {
                //     console.log(response.data)
                //     if(response.data.code == 2000){
                //         this.smsRes = response.data.message
                //         this.smsMsg=''
                //         linkarr = []
                // 	    this.links = []
                //     setTimeout(() => {
                //             this.smsRes=''
                //     }, 2000);
                //     }
                // }).catch(error => {
                //     console.log(error);
                // })
            },
            async sendVoiceCall(){
                console.log('sendVoiceCall clicked', { selectedAudio: this.selectedAudio, phoneNo: this.phoneNo, isVoiceLoading: this.isVoiceLoading })
                if(!this.selectedAudio){
                    this.voiceRes = 'Please select an activity audio file first'
                    setTimeout(() => { this.voiceRes = '' }, 3000)
                    return
                }
                if(this.phoneNo.length === 0){
                    this.voiceRes = 'No recipients selected. Go back and select a group with farmers.'
                    setTimeout(() => { this.voiceRes = '' }, 4000)
                    return
                }

                this.isVoiceLoading = true
                this.voiceRes = ''
                try {
                    const audioId = this.selectedAudio.audio?.id
                    if(!audioId){
                        this.voiceRes = 'Selected audio has no ID'
                        setTimeout(() => { this.voiceRes = '' }, 3000)
                        this.isVoiceLoading = false
                        return
                    }

                    var token = this.getCookie('token')
                    const response = await axios.post('https://aghub.miphost.com/api/cc/voice-call',
                        {
                            audio_id: audioId,
                            recipients: this.phoneNo,
                            campaign: 'Voice Advisory - ' + (this.selectedGroup?.label || 'Group')
                        },
                        { headers: { 'Authorization': `Bearer ${token}` } }
                    )
                    console.log('Backend voice call response', response.data)

                    if(response.data && response.data.message){
                        this.voiceRes = response.data.message
                        this.selectedAudio = null
                        setTimeout(() => { this.voiceRes = '' }, 3000)
                    } else {
                        this.voiceRes = 'Voice call failed'
                        setTimeout(() => { this.voiceRes = '' }, 4000)
                    }
                } catch (error) {
                    console.log('Voice call error', error)
                    this.voiceRes = 'Voice call failed: ' + (error.response?.data?.message || error.message || 'Unknown error')
                    setTimeout(() => { this.voiceRes = '' }, 4000)
                } finally {
                    this.isVoiceLoading = false
                }
            },            
            reloadList(){
                var token = this.getCookie('token')
                axios.get('https://aghub.miphost.com/api/broadcast/contact/show', 
                    { headers:{'Authorization': `Bearer ${token}`}})
                .then(response =>  {
                    this.contacts = response.data
                }).catch(error => {
                    console.log(error);
                })
            },
            getPodcasts(){
                var token = this.getCookie('token')

                axios.get('https://aghub.miphost.com/api/broadcast/podcast/', 
                    { headers:{'Authorization': `Bearer ${token}`}})
                .then(response =>  {
                   this.podcasts = response.data
                   axios.get('https://aghub.miphost.com/api/broadcast/podcasts/share', 
                        { headers:{'Authorization': `Bearer ${token}`}})
                    .then(response =>  {
                        response.data.forEach(podcast => {
                            if (podcast.accessPemission && podcast.accessPemission.includes('all')) {
                                this.publicPodcasts.push(podcast);
                            } else {
                                this.podcasts.push(podcast);
                            }
                        });
                    }).catch(error => {
                        console.log(error);
                    })
                }).catch(error => {
                    console.log(error);
                })
            },
            getPublicPodcasts(){
                var token = this.getCookie('token')

                axios.get('https://aghub.miphost.com/api/broadcast/podcasts/public', 
                    { headers:{'Authorization': `Bearer ${token}`}})
                .then(response =>  {
                   this.publicPodcasts = response.data
                }).catch(error => {
                    console.log(error);
                })
            },
            // crop advisory attachment methods
            getCrops(){
                var token = this.getCookie('token')
                axios.get('https://aghub.miphost.com/api/admin/cc/crops', 
                    { headers:{'Authorization': `Bearer ${token}`}})
                .then(response => {
                    this.crops = response.data || []
                }).catch(error => {
                    console.log(error);
                })
            },
            onCropSelected(){
                this.selectedActivity = null
                this.activityDetails = null
                this.cropActivities = []
                this.pendingAdvisory.includeDescription = false
                this.pendingAdvisory.selectedAdvisories = []
                if(!this.selectedCrop) return
                var token = this.getCookie('token')
                axios.get('https://aghub.miphost.com/api/admin/cc/activities/crop/' + this.selectedCrop, 
                    { headers:{'Authorization': `Bearer ${token}`}})
                .then(response => {
                    this.cropActivities = response.data || []
                }).catch(error => {
                    console.log(error);
                })
            },
            onActivitySelected(){
                this.activityDetails = null
                this.activityAudio = []
                this.selectedAudio = null
                this.pendingAdvisory.includeDescription = false
                this.pendingAdvisory.selectedAdvisories = []
                if(!this.selectedActivity) return
                var token = this.getCookie('token')
                axios.get('https://aghub.miphost.com/api/admin/cc/activities/' + this.selectedActivity, 
                    { headers:{'Authorization': `Bearer ${token}`}})
                .then(response => {
                    this.activityDetails = response.data
                    this.getActivityAudio()
                }).catch(error => {
                    console.log(error);
                })
            },
            getActivityAudio(){
                if(!this.selectedActivity) return
                var token = this.getCookie('token')
                axios.get('https://aghub.miphost.com/api/admin/cc/activities/' + this.selectedActivity + '/audio', 
                    { headers:{'Authorization': `Bearer ${token}`}})
                .then(response => {
                    this.activityAudio = response.data || []
                }).catch(error => {
                    console.log(error);
                })
            },
            toggleAdvisory(advId){
                const idx = this.pendingAdvisory.selectedAdvisories.indexOf(advId)
                if(idx > -1){
                    this.pendingAdvisory.selectedAdvisories.splice(idx, 1)
                } else {
                    this.pendingAdvisory.selectedAdvisories.push(advId)
                }
            },
            attachAdvisoryTexts(){
                this.advisoryPreview.forEach(item => {
                    if(!this.advisoryTexts.some(a => a.name === item.name && a.text === item.text)){
                        this.advisoryTexts.push(item)
                    }
                })
                this.pendingAdvisory.includeDescription = false
                this.pendingAdvisory.selectedAdvisories = []
            },
            removeAdvisoryText(index){
                this.advisoryTexts.splice(index, 1)
            },
            removeLink(index){
                this.links.splice(index, 1)
            },
            clearAllAttachments(){
                this.links = []
                this.advisoryTexts = []
            },
            getCookie(cname) {
                let name = cname + "=";
                let ca = document.cookie.split(';');
                for(let i = 0; i < ca.length; i++) {
                    let c = ca[i];
                    while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                    }
                }
                return "";
            },
            toggleVisibility(index) {
                this.extensions[index].extension.isPhoneVisible = !this.extensions[index].extension.isPhoneVisible;
                console.log(this.extensions[index])
            },
            maskPhone(phone) {
                return "*******" + phone.slice(-4);
            },
        },
    }
</script>
<style scoped>
    .action_badge:hover {
        background-color: #86d1fc;
        border-radius: 50%;
        
    }
    .input-group-text{
        background-color:#e9ecef00 !important;
        border: none !important;
        padding: 0px !important;
    }
    .input-group-text:hover{
        color:#037205 !important;
        cursor: pointer;
    }
    .btn-close{
        width: 3px !important;
        height: 3px !important;
        margin-top: 6px;
    }
    .alert a{
         margin-top: 3px !important;
         opacity: .6;

    }
    .alert a:hover{
         opacity: 1;
    }
    .alert{
        padding: 2px 14px !important;
        border-radius: 3px!important;
    }
        /* we will explain what these classes do next! */
        .v-enter-active,
        .v-leave-active {
        transition: opacity 2.5s ease;
        }

        .v-enter-from,
        .v-leave-to {
        opacity: 0;
        }
    .dropdown-toggle::after {
        display: none !important;
    }
    .card{
        margin-top:4%;
        /* min-height: 90% !important; */
        min-width: 80% !important;
        /* overflow-x: scroll; */
        border-radius: 5px;
        transition: 0.5s;
        background-color: #ffffff !important;
    }

    .stockList:hover>* {
        --bs-table-accent-bg: rgb(0 0 0 / 0%) !important;
    }

    .table-sm>:not(caption)>*>* {
        padding: 0.6rem .25rem !important;
    }

/* **************************** */

.form-control-sm {
    background-color: #1a222600;
    border: none;
    border-bottom: 1px solid #dc3545;
    border-top: 0px;
    border-radius: 0px;
    font-weight:500;
    outline: 0;
    margin-bottom: 20px;
    padding-left: 10px;
    color: rgb(36, 36, 36);
}
.form-control-sm{
    font-size: 0.75rem !important;
}
.form-control:focus {
    border-color: inherit;
    -webkit-box-shadow: none;
    box-shadow: none;
    border-bottom: 2px solid #dc3545 !important ;
    outline: 0;
    background-color: #31383b00;
    color: #000000;
}

input:focus {
    outline: none;
    box-shadow: 0 0 0;
}

label {
    margin-bottom: 0px;
}

.form-label {
    font-size: 10px;
    color: #464646;
    font-weight:500;
    letter-spacing: 1px;
}

.spinner-border {
    display: block  !important;;
    width: 1rem;
    height: 1rem;
    color: #dc3545;
    border: .2em solid currentColor;
    border-right-color: transparent !important;
}
.spinner-grow-sm {
    width: .45rem;
    height: .45rem;
    vertical-align: 0.576em !important;
    color: #f68888;
}

/* Messaging panel UX */
.messaging-card {
    border: 1px solid rgb(42 42 42) !important;
}
.message-composer {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    border-bottom: 1px solid #dc3545;
    padding-bottom: 4px;
}
.attachment-dropdown {
    flex-shrink: 0;
}
.attachment-btn:hover {
    color: #037205 !important;
}
.attachment-menu {
    width: 3.5in;
    max-width: 90vw;
}
.message-textarea {
    border: none !important;
    background: transparent !important;
    resize: none;
    min-height: 2.5rem;
    font-size: 0.85rem;
    padding: 0.25rem 0.5rem;
}
.message-textarea:focus {
    box-shadow: none !important;
    outline: none !important;
}
.attachment-chip {
    display: inline-flex;
    align-items: center;
    font-size: 11px;
    padding: 0.4em 0.7em;
    max-width: 160px;
    cursor: default;
}
.link-chip {
    background-color: #1f6c15;
    color: #fff;
}
.advisory-chip {
    background-color: #e6b600;
    color: #fff;
}
.voice-chip {
    background-color: #0d6efd;
    color: #fff;
}
.remove-chip {
    cursor: pointer;
    opacity: 0.8;
}
.remove-chip:hover {
    opacity: 1;
}
.send-btn:disabled {
    opacity: 0.75;
}
.alert-sm {
    font-size: 12px;
}

/* Stepper wizard */
.stepper-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
}
.stepper-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    cursor: pointer;
    z-index: 2;
}
.stepper-item.disabled {
    cursor: default;
    opacity: 0.6;
}
.stepper-item.active .step-counter,
.stepper-item.completed .step-counter {
    background-color: #1f6c15;
    color: #fff;
    border-color: #1f6c15;
}
.step-counter {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #fff;
    border: 2px solid #dee2e6;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 14px;
    color: #6c757d;
    transition: all 0.3s ease;
}
.step-name {
    margin-top: 6px;
    font-size: 12px;
    color: #6c757d;
    font-weight: 500;
}
.stepper-item.active .step-name,
.stepper-item.completed .step-name {
    color: #1f6c15;
    font-weight: 700;
}
.stepper-connector {
    position: absolute;
    top: 18px;
    left: 10%;
    right: 10%;
    height: 2px;
    background-color: #dee2e6;
    z-index: 1;
}
.stepper-connector.completed {
    background-color: #1f6c15;
}
.group-card {
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    border: 1px solid #e9ecef;
}
.group-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1) !important;
}
.group-card.border-success {
    border-width: 2px !important;
}
</style>
